import type { ActiveGateway } from '../../types/context.types';

export type GatewayRendererProps<StripeProps, JustifiProps> = React.PropsWithChildren<{
  activeGateway: ActiveGateway | undefined;
  stripeContent: React.FC<StripeProps>;
  justifiContent: React.FC<JustifiProps>;
  stripeProps: StripeProps;
  justifiProps: JustifiProps;
}>;

/** `GatewaySwitch` without the processor-data context, for callers that already know the gateway. */
export function GatewayRenderer<StripeProps, JustifiProps>({
  activeGateway,
  children,
  stripeContent: StripeContent,
  justifiContent: JustifiContent,
  stripeProps,
  justifiProps,
}: GatewayRendererProps<StripeProps, JustifiProps>) {
  return (
    <>
      {activeGateway === 'stripe' && typeof StripeContent === 'function' && (
        <StripeContent {...stripeProps}>{children}</StripeContent>
      )}
      {activeGateway === 'justifi' && typeof JustifiContent === 'function' && (
        <JustifiContent {...justifiProps}>{children}</JustifiContent>
      )}
    </>
  );
}
